import * as React from 'react';
import { lazyLoad } from '../../../utils/loadable';

export const HealthPage = props => {
  return lazyLoad(
    () => import('./index'),
    module => module.HealthPage,
    { fallback: <div></div> },
  )(props);
};
